// @flow

export const UPDATE_TIMER: 'timer:update' = 'timer:update';
